import { saveAs } from 'file-saver';

export const saveFile = (fileBlob: BlobPart) => {
  const file = new Blob([fileBlob], {
    type: 'data:text/csv;charset=utf-8,',
  });
  saveAs(file, 'Example CSV file.csv');
};
